import { AxiosPromise } from 'axios';
import { http } from 'services';

/**
 * One rung of the AI capability ladder, as shown in the chat composer.
 *
 * The web app deliberately never sees a model name: which model backs a tier is
 * an operations decision made in the admin console and changed without a
 * release. `GET /api/llm/models/available` still exists on the API as the guard
 * behind the legacy raw-model request field, but nothing here calls it.
 */
export interface ChatTier {
  key: string;
  label: string;
  tagline: string;
  description: string;
  /** True when the org's plan does not include this tier. Still rendered — it is the upsell. */
  locked: boolean;
}

export const GetChatTiers = (): AxiosPromise<ChatTier[]> =>
  http.request.get('/api/llm/tiers/available');
